import React from 'react';
export const IntroSection = () => {
  return <section className="mb-16 text-center" data-id="element-23">
      <div className="max-w-3xl mx-auto" data-id="element-24">
        <p className="text-lg text-gray-700 mb-6" data-id="element-25">
          For years, taking control of your health with a wearable meant
          choosing between two flawed options: a bulky smartwatch that needs
          charging every night, or a minimalist ring that traps you in a
          frustrating monthly subscription just to see your own data.
        </p>
        <p className="text-lg text-gray-700 mb-6" data-id="element-26">
          Many of us have tried both, only to end up with an expensive gadget
          gathering dust in a drawer.
        </p>
        <p className="text-lg text-gray-700 mb-6" data-id="element-27">
          That's why when the Zenora Ring launched—offering pinpoint accuracy
          with zero subscriptions—it sold out almost instantly. Here are the 5
          reasons people are making the switch.
        </p>
      </div>
    </section>;
};